

// // TermsAndConditions.jsx

// import React from "react";
// import { useParams } from "react-router-dom";

// const TermsAndConditions = () => {

//   const { beautyparam } = useParams();

//   const ussdMap = {
//     woh: "*179*555#",
//     puzzles: "*179*521#",
//     sports: "*179*522#",
//     luxury: "*179*523#",
//     fashion: "*179*524#",
//     beauty: "*179*525#",
//     cashhub: "*179*159#",
//     faith: "*179*122#",
//     business: "*179*556#",
//     games: "*179*557#",
//     topics: "*179*558#",
//     loltv: "*179*559#",
//     videos: "*179*560#",
//   };

//   const subscribeUssd =
//     ussdMap[beautyparam?.toLowerCase()] || "*179#";

//   return (
//     <div className="min-h-screen bg-[white] text-[black] px-6 py-12">
//       <div className="max-w-4xl mx-auto">

//         <h1 className="text-3xl md:text-4xl font-bold mb-6 underline">
//           Terms & Conditions
//         </h1>

//         <h2 className="text-xl font-semibold mb-4">
//           Consent to Use of Personal Information for Marketing and Database
//           Purposes
//         </h2>

//         <p className="mb-4">
//           By accessing and using our services, you expressly consent to Ndoto
//           Media (PTY) LTD collecting, storing, and using your personal
//           information, including but not limited to your phone number, for the
//           following purposes:
//         </p>

//         <p className="mb-4 font-semibold">
//           To subscribe dial USSD {subscribeUssd}
//         </p>

//       </div>
//     </div>
//   );
// };

// export default TermsAndConditions;



import React from "react";
import { useParams } from "react-router-dom";

const TermsAndConditions = () => {
  const { beautyparam } = useParams();

  const ussdMap = {
    woh: "*179*555#",
    puzzles: "*179*521#",
    sports: "*179*522#",
    luxury: "*179*523#",
    fashion: "*179*524#",
    beauty: "*179*525#",
    cashhub: "*179*159#",
    faith: "*179*122#",
    business: "*179*556#",
    games: "*179*557#",
    topics: "*179*558#",
    loltv: "*179*559#",
    videos: "*179*560#",
  };

  const subscribeUssd =
    ussdMap[beautyparam?.toLowerCase()] || "*179#";
  return (
    <div className="min-h-screen bg-[white] text-[black] px-6 py-12">
      <div className="max-w-4xl mx-auto">
        {/* Page Title */}
        <h1 className="text-3xl md:text-4xl font-bold mb-6 underline">
          Terms & Conditions
        </h1>

        {/* Consent Heading */}
        <h2 className="text-xl font-semibold mb-4">
          Consent to Use of Personal Information for Marketing and Database
          Purposes
        </h2>

        {/* Terms Content */}
        <p className="mb-4">
          By accessing and using our services, you expressly consent to Ndoto
          Media (PTY) LTD collecting, storing, and using your personal
          information, including but not limited to your phone number, for the
          following purposes:
        </p>

        <ul className="list-disc list-inside space-y-2 mb-6">
          <li>
            Sending you marketing communications, promotions, service updates,
            and special offers via SMS, WhatsApp, or other direct messaging
            platforms;
          </li>
          <li>
            Conducting surveys, collecting feedback, and informing you about new
            content, services, or features that may be relevant to you;
          </li>
          <li>
            Building and maintaining a customer and user database for internal
            research, service optimization, and future communication.
          </li>
        </ul>

        {/* Acknowledgement Section */}
        <h3 className="text-lg font-semibold mb-3">You acknowledge and agree that:</h3>
        <ul className="list-disc list-inside space-y-2 mb-6">
          <li>
            Your information will be stored securely and only used for the
            purposes mentioned above;
          </li>
          <li>
            You may opt-out of marketing communications at any time by following
            the unsubscribe instructions provided in any communication or by
            contacting us directly at{" "}
            <span className="underline">[insert contact email or opt-out method]</span>;
          </li>
          <li>
            We will not sell or share your personal information with any third
            party without your explicit consent, except where required by law or
            where necessary to provide the service.
          </li>
        </ul>

        {/* Compliance Section */}
        <p>
          Ndoto Media processes your data in accordance with the Protection of
          Personal Information Act (POPIA) and any other applicable privacy
          regulations.
        </p>

         <p className="mb-4">
          To subscribe dial {subscribeUssd}
        </p>
      </div>
    </div>
  );
};

export default TermsAndConditions;